import { type Palette } from "@mui/joy";
import { type DataType } from "./dataNode";

export const DATA_TYPE_COLOR: Record<DataType, keyof Palette["chip"]> = {
  table: "gin",
  unstructured: "marzipan",
};
